import { Button } from "@/components/ui/button";
import { User, LogOut, Code } from "lucide-react";
import { useAuth } from "@/lib/store/auth-store";

export function LoginButton({ vertical = false }: { vertical?: boolean }) {
  const { user, loading, login, logout } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center gap-2">
        <div className="h-4 w-4 animate-spin rounded-full border-2 border-muted-foreground border-t-transparent" />
      </div>
    );
  }

  if (user) {
    return (
      <div className={`flex ${vertical ? 'flex-col' : 'items-center'} ${vertical ? 'gap-2' : 'gap-3'}`}>
        {user.picture && (
          <img
            src={user.picture}
            alt={user.name}
            className="h-8 w-8 rounded-full"
          />
        )}
        <div className="flex flex-col">
          <span className="text-sm font-medium text-foreground">{user.name}</span>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={logout}
          className="text-muted-foreground hover:text-foreground"
        >
          <LogOut className="h-4 w-4" />
        </Button>
      </div>
    );
  }

  const isDevelopment = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

  return (
    <div className={`flex ${vertical ? 'flex-col' : 'items-center'} gap-2 w-full`}>
      {isDevelopment && (
        <Button
          variant="outline"
          size="sm"
          onClick={() => login("dev")}
          className={`border-yellow-500 text-yellow-600 hover:bg-yellow-50 dark:hover:bg-yellow-950 ${vertical ? 'w-full justify-start' : ''}`}
        >
          <Code className="h-4 w-4 mr-2" />
          Dev Login
        </Button>
      )}
      <Button
        variant="outline"
        size="sm"
        onClick={() => login("discord")}
        className={vertical ? 'w-full justify-start' : ''}
      >
        <User className="h-4 w-4 mr-2" />
        Login with Discord
      </Button>
    </div>
  );
}

